/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { Group } from '@mantine/core';
import type React from 'react';

export function HeaderContentContainer({
  leftItems,
  rightItems,
}: {
  leftItems: React.ReactElement;
  rightItems: React.ReactElement;
}) {
  return (
    <Group gap={0} h="100%" justify="space-between" px={0} wrap="nowrap">
      <Group gap={0} h="100%" wrap="nowrap">
        {leftItems}
      </Group>
      <Group gap={0} wrap="nowrap">
        {rightItems}
      </Group>
    </Group>
  );
}
